import { render, staticRenderFns } from "./MspRemuOption.vue?vue&type=template&id=3bb6454c&scoped=true&"
import script from "./MspRemuOption.vue?vue&type=script&lang=ts&"
export * from "./MspRemuOption.vue?vue&type=script&lang=ts&"
import style0 from "./MspRemuOption.vue?vue&type=style&index=0&id=3bb6454c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb6454c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VContainer,VDivider,VSimpleTable})
